import { Location } from '$domain/model/map/map.model'

const get = (addressComponents, name) => {
  const nameComponent = addressComponents.find(component => component.types[0] === name)
  if (nameComponent) {
    return nameComponent.long_name
  }
  return undefined
}

const getStreetNumber = addressComponents => {
  return get(addressComponents, 'street_number')
}

const getRoute = addressComponents => {
  return get(addressComponents, 'route')
}

const getPostalCode = addressComponents => {
  return get(addressComponents, 'postal_code')
}

const getLocality = addressComponents => {
  return get(addressComponents, 'locality')
}

const getProvince = addressComponents => {
  return get(addressComponents, 'administrative_area_level_2')
}

const getCountry = addressComponents => {
  return get(addressComponents, 'country')
}

export const rawAddressToModel = rawAddress => {
  const location: Location = {
    latitude: rawAddress.geometry.location.lat,
    longitude: rawAddress.geometry.location.lng,
    address: `${getRoute(rawAddress.address_components)}, ${getStreetNumber(rawAddress.address_components)}`,
    postalCode: getPostalCode(rawAddress.address_components),
    town: getLocality(rawAddress.address_components),
    formattedAddress: rawAddress.formatted_address,
    province: getProvince(rawAddress.address_components),
    country: getCountry(rawAddress.address_components),
  }
  return location
}



// WEBPACK FOOTER //
// ./src/domain/model/map/map.mapper.ts